/* eslint-disable */
import {gsap} from "gsap";
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const NavigationArrows = {
  init: function () {
    const arrowsBTNs = document.querySelectorAll('[data-navigation-arrow-js]');
    if (!arrowsBTNs.length) return;

    arrowsBTNs.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();

        this.initBtn(button);
      })
    })
  },

  initBtn: function (button) {
    const sections = document.querySelectorAll('section:not(.pattern-block)');
    const body = document.getElementsByTagName('body')
    const currentSection = button.closest('section');
    const currentIndex = Array.from(sections).indexOf(currentSection);

    if(button.classList.contains('sk-navigation-arrow--bottom')) {
      const nextSectionIndex= currentIndex + 1;

      if (nextSectionIndex && sections[nextSectionIndex]) {
        const targetSection = sections[nextSectionIndex];
        const sectionInnerToScroll = targetSection.querySelector('[data-section-inner-js]');
        const target = sectionInnerToScroll || targetSection;

        this.smoothScrollTo(target);
      }
    } else {
      this.smoothScrollTo(body);
    }
  },

  smoothScrollTo: function (target) {
    gsap.to(window, {
      duration: 0.7,
      scrollTo: {
        y: target,
        offsetY: 50,
        autoKill: false,
      },
      ease: "ease.inOut"
    });
  },

}

export default NavigationArrows;


